/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Rails_AlternativesInputs */

const en_directory_rails_alternatives = /** @type {(inputs: Directory_Rails_AlternativesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alternatives`)
};

const zh_directory_rails_alternatives = /** @type {(inputs: Directory_Rails_AlternativesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`替代方案`)
};

/**
* | output |
* | --- |
* | "Alternatives" |
*
* @param {Directory_Rails_AlternativesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_rails_alternatives = /** @type {((inputs?: Directory_Rails_AlternativesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Rails_AlternativesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_rails_alternatives(inputs)
	return zh_directory_rails_alternatives(inputs)
});
export { directory_rails_alternatives as "directory.rails.alternatives" }